export default "__VITE_ASSET__B0NZ6K6o__"